import { Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { finalize, map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

const VERSION_SIDENAV_HIDDEN = 'screen and (max-width: 959px)';

@Injectable({ providedIn: 'root' })
export class MediasQueryService {

    constructor(
        private breakpointObserver: BreakpointObserver
    ) { }

    isMobile(): Observable<boolean> {
        return this.breakpointObserver.observe([VERSION_SIDENAV_HIDDEN])
        .pipe(
            map(state => state.breakpoints[VERSION_SIDENAV_HIDDEN])
        );
    }
}
